module.exports = __webpack_public_path__ + "static/media/gift.c4332546.gif";